import { isMobilityPulseAdsEnabled } from '@client/adManager/AdUnit/utils/isMobilityPulseAdsEnabled.js';
import { updateMetricByKey } from '@client/core/atoms/metrics.js';
import { trackAdViewable } from '@client/core/utils/pulse/adImpressions.js';
import {
  type PlacementId,
  PlacementStatus
} from '@schibsted-nmp/advertising-shared';

/** Fired when an impression becomes viewable. */
export function onImpressionViewable(
  event: googletag.events.ImpressionViewableEvent
) {
  const { slot } = event;
  const placementId = slot.getSlotElementId() as PlacementId;
  updateMetricByKey(placementId, PlacementStatus.AdViewed);

  if (isMobilityPulseAdsEnabled()) trackAdViewable(slot);
}
